import React from 'react';
import { ScrollReveal } from '../ui/ScrollReveal';
import { CTAButton } from '../ui/CTAButton';
import { ZapIcon } from 'lucide-react';
import { useCurrencyByIP } from '../../hooks/useCurrencyByIP';
export function PricingSection() {
  const {
    price,
    isLoading
  } = useCurrencyByIP();
  return <section id="pricing" className="w-full py-20 md:py-32 px-5" data-id="element-79">
      <div className="max-w-3xl mx-auto" data-id="element-80">
        {/* Pricing card */}
        <ScrollReveal data-id="element-81">
          <div className="relative bg-surface border border-accent/20 rounded-3xl p-8 md:p-12 text-center overflow-hidden" data-id="element-82">
            {/* Background glow */}
            <div className="absolute inset-0 pointer-events-none" style={{
            background: 'radial-gradient(ellipse at top center, rgba(255,107,0,0.06) 0%, transparent 60%)'
          }} data-id="element-83" />

            <div className="relative" data-id="element-84">
              <div className="flex items-center justify-center gap-2 mb-4" data-id="element-85">
                <ZapIcon className="w-5 h-5 text-accent" data-id="element-86" />
                <span className="text-sm font-semibold tracking-widest uppercase text-accent" data-id="element-87">
                  Hook Arsenal
                </span>
              </div>

              <div className="mb-2" data-id="element-88">
                <span className={`text-5xl md:text-6xl font-extrabold text-white transition-opacity duration-300 ${isLoading ? 'opacity-50' : 'opacity-100'}`} data-id="element-89">
                  {price}
                </span>
              </div>

              <p className="text-neutral-400 mb-8 text-lg" data-id="element-90">
                Diseñado para ser una compra fácil y útil desde el minuto 1.
              </p>

              <CTAButton className="mx-auto" data-id="element-91">
                Quiero HOOK ARSENAL (200 ganchos + plantillas)
              </CTAButton>
            </div>
          </div>
        </ScrollReveal>

        {/* Final close */}
        <ScrollReveal delay={0.15} data-id="element-92">
          <div className="mt-20 md:mt-28 space-y-6 text-lg md:text-xl leading-relaxed text-neutral-300 text-center" data-id="element-93">
            <p data-id="element-94">
              Si hoy te sientes{' '}
              <span className="font-serif-italic text-accent-light text-2xl" data-id="element-95">
                invisible
              </span>{' '}
              en Reels, no necesitas más motivación.
            </p>
            <p className="text-white font-bold text-xl md:text-2xl" data-id="element-96">
              Necesitas un inicio que no se pueda ignorar.
            </p>
            <div className="pt-4 space-y-1" data-id="element-97">
              <p className="text-neutral-400" data-id="element-98">Deja de empezar con "Hola".</p>
              <p className="text-white font-bold text-2xl md:text-3xl" data-id="element-99">
                Empieza con <span className="text-accent" data-id="element-100">tensión.</span>
              </p>
            </div>
          </div>
        </ScrollReveal>

        {/* PS */}
        <ScrollReveal delay={0.2} data-id="element-101">
          <div className="mt-20 md:mt-28 pt-8 border-t border-border/50" data-id="element-102">
            <p className="text-sm md:text-base text-neutral-500 leading-relaxed" data-id="element-103">
              <span className="text-neutral-400 font-semibold" data-id="element-104">P.D.</span> Si
              publicas hoy, abre con uno de los ganchos del PDF. No mañana.{' '}
              <span className="text-neutral-300" data-id="element-105">Hoy.</span> Porque el
              crecimiento no premia al que "sabe"…{' '}
              <span className="text-neutral-300 font-semibold" data-id="element-106">
                premia al que ejecuta.
              </span>
            </p>
          </div>
        </ScrollReveal>
      </div>
    </section>;
}